import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_facilitymanage-2/artifacts/3hcvfjhr_WhatsApp-Image-2026-02-02-at-13.09.08-e1770033239466.jpeg"
              alt="Ozone A-1 Services"
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Integrated Facility & Staffing Solutions. Reliable, Compliant, Performance-Driven.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li className="text-gray-400 text-sm">Soft Services</li>
              <li className="text-gray-400 text-sm">Engineering Services</li>
              <li className="text-gray-400 text-sm">Security & Safety</li>
              <li className="text-gray-400 text-sm">Maintenance & Repair</li>
              <li className="text-gray-400 text-sm">Staffing Solutions</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#1C4BB6] mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">
                  P-16, Sector Platinum, Shree Ram Square, Indore, MP - 452001
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-[#1C4BB6] flex-shrink-0" />
                <span className="text-gray-400 text-sm">+91 9993892419</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-[#1C4BB6] flex-shrink-0" />
                <span className="text-gray-400 text-sm">operations@ozoneservices.in</span>
              </li>
            </ul>

            {/* Social Links */}
            <div className="flex space-x-4 mt-6">
              <a href="#" className="text-gray-400 hover:text-[#1C4BB6] transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#1C4BB6] transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#1C4BB6] transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#1C4BB6] transition-colors">
                <Instagram size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Ozone A-1 Services Pvt. Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
